import React from 'react';
import {connect} from 'react-redux';
import GeneralRequest from "./GeneralRequest";
import ColumnResizer from "react-column-resizer";
import CommonList from "../../parts/CommonListClass";
import Search from "../../parts/Search";
import ToolButtons from "../../parts/ToolButtons";
import {doFilter} from "../../parts/functions";
import {ActionGeneralUnitAdd, ActionGeneralUnitDelete, ActionGeneralUnitEdit} from "../../parts/actions";
import Storege from "../../storage/storage";
import RemoveButton from "../../parts/removeBtn";
import GeneralDataDescriptorUnitAdd from "./general_data_descriptor_unit_add";
import EditBtn from "../../parts/EditBtn";

class GeneralDataDescriptorComponent extends CommonList {
    orderFields = {
        "Unit Name": 'generalunitname',
        "Unit Name Eng": 'generalunitnameeng',
        "Description": 'description'
    };

    state = {
        items: {},
        popup: false,
        searchValue: '',
        popupType: undefined,
        currentItemIndex: -1,
        rowIndex: -1,
        order: null
    };

    constructor(props) {
        super(props);
        this.state.items = props.items;
    }


    changeStateUnit = (name, e, id) => {
        let temp = this.props.items;
        temp.forEach(function (item) {
            if (item.generalunitid == id) {
                item[name] = e.value;
            }
        });
        this.setState({
            items: Object.assign({}, temp)
        });
    };

    orderPanel = () => {
        let fields = [];
        if (this.orderFields) {
            for (let label in this.orderFields) {
                fields.push((
                    <React.Fragment>
                        <th>
                            <a className="sort-items" onClick={() => {
                                this.setOrder(this.orderFields[label])
                            }}><h4>{label}</h4>{this.diractionSymbol(this.orderFields[label])}</a>
                        </th>
                        {Object.keys(this.orderFields).indexOf(label) !== Object.keys(this.orderFields).length - 1 ?
                            <ColumnResizer className="columnResizer" minWidth={5}/> : ''}
                    </React.Fragment>
                ))
            }
        }
        if (fields.length) {
            return (
                <tr className={'sortable-btn'}>
                    <th></th>
                    {fields}
                </tr>
            )
        }
        return null;
    };

    addContentType = (object) => {
        ActionGeneralUnitAdd('', object).then(data => {
            Storege.dispatch({
                type: 'ADD GENERAL UNIT',
                item: data
            });
            this.changePopupState();
        });
    };


    editContentType = (object) => {
        ActionGeneralUnitEdit(object.generalunitid, object).then(data => {
            Storege.dispatch({
                type: 'UPDATE GENERAL UNIT',
                item: data,
                id: data.generalunitid
            });
            this.changePopupState();
        });
    };

    render() {
        if (!this.props.items.length) {
            GeneralRequest('general');
        }
        let {items} = this.props;
        let {searchValue} = this.state;

        items = doFilter(items, [
            {
                name: 'searchValue',
                value: searchValue,
                searchId: [
                    'generalunitname',
                    'generalunitnameeng'
                ]
            }
        ]);

        this.sortResults(items);

        return (
            <div>
                <div className="inline-toolbuttons">
                    <h3>Units</h3>
                    <div className={'tool-bar'}>
                        <ToolButtons
                            actionType={this.changePopupType}
                            popupChange={this.changePopupState}
                            id={this.state.currentItemIndex}
                        />
                        <Search
                            change={this.search}
                            id={'general-search'}
                        />
                    </div>
                </div>
                <table className={'table table-striped'}>
                    <thead>
                    {this.orderPanel()}
                    </thead>
                    <tbody>
                    {items.map((item, index) => {
                        return (
                            <tr key={index} onClick={
                                () => {
                                    this.setState({
                                        rowIndex: index,
                                        currentItemIndex: item.generalunitid
                                    });
                                }
                            } className={'list-group-item clear' + (this.state.rowIndex == index ? ' active' : '')}>
                                <td>
                                    <div className="flex-row">
                                        <RemoveButton
                                            action={ActionGeneralUnitDelete}
                                            id={item.generalunitid}
                                            descriptor={'REMOVE GENERAL UNIT'}
                                        />
                                        <EditBtn
                                            actionType={this.changePopupType}
                                            popupChange={this.changePopupState}
                                            change={this.setCurrentIndex}
                                            id={item.generalunitid}
                                        />
                                    </div>
                                </td>
                                <td>{item.generalunitname}</td>
                                <ColumnResizer className="columnResizer" minWidth={5}/>
                                <td>{item.generalunitnameeng}</td>
                                <ColumnResizer className="columnResizer" minWidth={5}/>
                                <td>{item.description}</td>
                            </tr>
                        )
                    })}
                    </tbody>
                </table>
                {this.state.popup ? <GeneralDataDescriptorUnitAdd
                    close={this.changePopupState}
                    action={this.state.popupType == 'add' ? this.addContentType : this.editContentType}
                    button={this.state.popupType == 'add' ? 'Add' : 'Update'}
                    id={this.state.popupType == 'edit' ? this.state.currentItemIndex : -1}
                /> : ''}
            </div>
        )
    }
}


const mapStateToProps = (state, ownProps) => {
    return {
        items: state.generalDataDescriptorUnits
    }
};
const GeneralDataDescriptorUnit = connect(mapStateToProps)(GeneralDataDescriptorComponent);

export default GeneralDataDescriptorUnit;